import React from 'react';
import { useTranslation } from 'react-i18next';
import { RowCard, StatusPill } from '../patterns';
import type { PhiTrackerRow } from '../../services/sprayDashboardService';
import { formatDate } from '../../dateFormat';

const VISIBLE_LIMIT = 5;

export interface SprayPhiTrackerCardProps { rows: PhiTrackerRow[]; horizon: Date }

const PhiRowBody: React.FC<{ row: PhiTrackerRow; horizon: Date }> = ({ row, horizon }) => {
  const { t } = useTranslation();
  const isLongPhi = new Date(row.earliestSafeHarvest) > horizon;
  return (
    <div className="spray-dashboard__phi-row">
      <div className="spray-dashboard__phi-row-name">{row.orchardName ?? row.orchardId}</div>
      <div className="spray-dashboard__phi-row-meta">
        <span>{t('spray.dashboard.phi.safeBy', { date: formatDate(row.earliestSafeHarvest) })}</span>
        {isLongPhi && <StatusPill variant="warn">{t('spray.dashboard.phi.longPhiChip')}</StatusPill>}
        {row.phiNotes.map(n => (
          <StatusPill key={n.productName} variant="info">
            {t('spray.dashboard.phi.unmappedPhiChip', { note: n.value })}
          </StatusPill>
        ))}
      </div>
    </div>
  );
};

export const SprayPhiTrackerCard: React.FC<SprayPhiTrackerCardProps> = ({ rows, horizon }) => {
  const { t } = useTranslation();
  if (rows.length === 0) return null;
  const visible = rows.slice(0, VISIBLE_LIMIT);
  return (
    <section className="spray-dashboard__list-card" data-testid="spray-phi-card">
      <header className="spray-dashboard__list-card-header">
        <h3 className="spray-dashboard__list-card-title">{t('spray.dashboard.phi.title')}</h3>
      </header>
      <div className="spray-dashboard__list-card-body">
        {visible.map(row => (
          <RowCard key={row.orchardId} testId={`phi-row-${row.orchardId}`}>
            <PhiRowBody row={row} horizon={horizon} />
          </RowCard>
        ))}
      </div>
    </section>
  );
};

export default SprayPhiTrackerCard;
